export default [
  {
    path: '/main/activesmovementbatch',
    name: 'activesmovementbatch',
    meta: {
      tag: 'activesmovementbatch',
      name: 'Movimentação de Ativos (Em Lote)',
      breadcrumb: 'Movimentação de Ativos (Em Lote)'
    },
    component: () => import(/* webpackChunkName: "activesmovementbatch-list" */ '@/views/main/activesmovementbatch/Index.vue')
  }
]